const cleanString = (value) => (typeof value === 'string' ? value.trim() : '');

export const ARCHIVE_IMPORT_TERMINAL_EVENT = 'casedb:archive-import-terminal';

/**
 * Resolve only the retry authority explicitly published by the archive API.
 *
 * Failure codes are explanatory, not authority. In particular, an older job
 * may have a generic extraction failure even though the server has since
 * verified that its preserved package can accept a password. The UI therefore
 * requires the current terminal response's availability flag and opaque token
 * for every retry, including password-required and password-reentry failures.
 */
export const resolveArchivePasswordRetry = (job) => {
  const status = cleanString(job?.status).toLowerCase();
  const jobId = cleanString(job?.job_id || job?.public_id);
  const retryToken = cleanString(job?.password_retry_token);
  const explicitlyAvailable = job?.password_retry_available === true;

  if (status !== 'failed'
    || job?.terminal !== true
    || !explicitlyAvailable
    || !jobId
    || !retryToken) {
    return null;
  }

  return {
    jobId,
    retryToken,
    failureCode: cleanString(job?.error_code || job?.failure_code),
  };
};

export const archiveImportJobFromResponse = (response) => (
  response?.job || response?.archive_import || response || {}
);
